module.exports = __webpack_public_path__ + "img/bar-chart-light-02.b782a0ee.jpg";